import type { CallCenterStyles } from "../../types";
import type { SxProps, Theme } from "@mui/material";

const getStyles = (): Record<CallCenterStyles, SxProps<Theme>> => {
  return {
    root: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      width: "50%",
    },
  };
};

export default getStyles;
